export const MAX_VISIBLE_TOASTS = 3
